import React from "react";
import { cn } from "../../libs/utils";

const Card = React.forwardRef(function Card(
  { as: Comp = "div", className, ...props },
  ref
) {
  return (
    <Comp
      ref={ref}
      className={cn(
        "rounded-lg bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)]",
        className
      )}
      {...props}
    />
  );
});

const CardHeader = ({ className, ...props }) => (
  <div
    className={cn("border-b border-slate-100 px-4 py-3", className)}
    {...props}
  />
);

const CardTitle = ({ children, className, ...props }) => (
  <h2
    className={cn("text-sm font-semibold text-gray-900", className)}
    {...props}
  >
    {children}
  </h2>
);

const CardContent = ({ className, ...props }) => (
  <div className={cn("p-4", className)} {...props} />
);

export { Card, CardContent, CardHeader, CardTitle };
